// Top-level navigation to the worker's /oauth/zoho/init route, with the
// current Supabase JWT in `?bearer=`. The route accepts the bearer in the
// query string because top-level navigation can't carry an Authorization
// header (see apps/dial-api/src/oauth/routes.ts). The user lands on Zoho's
// consent screen, grants, then Zoho 302s back to /oauth/zoho/callback.

const apiBaseUrl =
  import.meta.env.VITE_DIAL_API_URL?.trim() || import.meta.env.VITE_API_BASE_URL?.trim() || '';

export async function connectZoho(getAccessToken: () => Promise<string | null>): Promise<void> {
  const token = await getAccessToken();
  if (!token) throw new Error('Not signed in.');
  if (!apiBaseUrl) throw new Error('VITE_DIAL_API_URL not configured.');
  window.location.assign(`${apiBaseUrl}/oauth/zoho/init?bearer=${encodeURIComponent(token)}`);
}
